<nz-layout class="app">
  <router-outlet></router-outlet>
  <nz-footer class="bg-transparent" *ngIf="showFooter">
    <p class="text-center text-black text-opacity-45">
      &copy;&nbsp;{{ year }} BITE Alternative Investments. All rights
      reserved.&nbsp;Version {{ version }}
    </p>
  </nz-footer>
</nz-layout>
